export { default } from "./OrganizationSchemaMarkup.jsx";
